import React from "react";
import "./TabSelector.scss";

export default function TabSelector({
  name,
  activate,
  color,
  active,
  onClick,
}) {
  return (
    <button
      onClick={onClick}
      className="tab-selector"
      title="Сумаараа удирдана уу < >"
      style={{
        backgroundColor: active ? color : "#fff",
        color: active && "#fff",
      }}
    >
      {name}
    </button>
  );
}
